import { sendAIFCExperienceTrackingToParent } from './index';

const REMIX_REGENERATE_EXPERIENCE = 'aiMateRemixRegenerate';

export const remixRegenerateExperience: {
	start: () => void;
	success: () => void;
	fail: (args: { error: string }) => void;
	abort: (args: { reason: string }) => void;
} = {
	start: () =>
		sendAIFCExperienceTrackingToParent({
			status: 'start',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
		}),
	success: () =>
		sendAIFCExperienceTrackingToParent({
			status: 'success',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
		}),
	fail: ({ error }) =>
		sendAIFCExperienceTrackingToParent({
			status: 'fail',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			error,
		}),
	abort: ({ reason }) =>
		sendAIFCExperienceTrackingToParent({
			status: 'abort',
			experienceName: REMIX_REGENERATE_EXPERIENCE,
			reason,
		}),
};
